// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.orders-page {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding: 20px;
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.3), rgba(139, 92, 246, 0.3));
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
  border-radius: 10px;
  color: var(--text-primary, #e2e8f0);
}

.page-header h1 {
  margin: 0;
  font-size: 2rem;
  color: var(--text-primary, #e2e8f0);
}

/* Source Filter Tabs */
.source-filter-tabs {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  padding: 15px;
  background: rgba(255, 255, 255, 0.03);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  flex-wrap: wrap;
}

.source-tab {
  padding: 10px 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 500;
  color: rgba(226, 232, 240, 0.7);
  transition: all 0.3s;
  position: relative;
}

.source-tab:hover {
  border-color: rgba(99, 102, 241, 0.4);
  color: #e2e8f0;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);
}

.source-tab.active {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.3), rgba(139, 92, 246, 0.3));
  color: white;
  border-color: rgba(99, 102, 241, 0.4);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.source-tab.active::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 30px;
  height: 3px;
  background: #6366f1;
  border-radius: 2px;
}

/* Search and Filter */
.search-filter-bar {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

/* Status Filter Section */
.status-filter-section {
  background: rgba(255, 255, 255, 0.03);
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 30px;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.status-filter-section h3 {
  margin: 0 0 15px 0;
  color: var(--text-primary, #e2e8f0);
  font-size: 1.1rem;
}

.status-checkboxes {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
}

.status-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  transition: all 0.3s;
}

.status-checkbox:hover {
  background: rgba(255, 255, 255, 0.08);
  transform: translateY(-1px);
}

.status-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.status-checkbox span {
  font-weight: 500;
  font-size: 0.95rem;
  color: var(--text-primary, #e2e8f0);
}

.status-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.status-actions button {
  padding: 8px 16px;
  font-size: 0.9rem;
}

.search-box {
  flex: 1 1;
  min-width: 300px;
  position: relative;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 8px;
  padding: 0 15px;
}

.search-box svg {
  color: rgba(226, 232, 240, 0.5);
  margin-right: 10px;
}

.search-box input {
  flex: 1 1;
  border: none;
  outline: none;
  padding: 12px 0;
  font-size: 1rem;
  background: transparent;
  color: var(--text-primary, #e2e8f0);
}

.search-box input::placeholder {
  color: rgba(226, 232, 240, 0.4);
}

.status-filter {
  padding: 12px 20px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.05);
  color: var(--text-primary, #e2e8f0);
  font-size: 1rem;
  cursor: pointer;
  outline: none;
  transition: border-color 0.3s;
}

.status-filter:focus {
  border-color: rgba(99, 102, 241, 0.5);
}

/* Order Form */
.order-form {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
  border-radius: 10px;
  padding: 25px;
  margin-bottom: 30px;
}

.order-form h2 {
  margin-top: 0;
  color: var(--text-primary, #e2e8f0);
  margin-bottom: 20px;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  color: rgba(226, 232, 240, 0.8);
  font-weight: 500;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 10px 15px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  font-size: 1rem;
  transition: border-color 0.3s;
  background: rgba(255, 255, 255, 0.05);
  color: var(--text-primary, #e2e8f0);
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: rgba(226, 232, 240, 0.35);
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: rgba(99, 102, 241, 0.5);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.form-group select option {
  background: #1e293b;
  color: #e2e8f0;
}

.form-group textarea {
  resize: vertical;
  font-family: inherit;
}

/* Image Section */
.image-section {
  margin: 20px 0;
  padding: 20px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 8px;
}

.image-section label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 15px;
  color: rgba(226, 232, 240, 0.8);
  font-weight: 500;
}

.image-controls {
  display: flex;
  gap: 10px;
  margin-bottom: 15px;
  flex-wrap: wrap;
}

.image-preview {
  max-width: 500px;
  margin: 15px 0;
  border: 2px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.image-preview img {
  width: 100%;
  height: auto;
  display: block;
}

/* Image Editor Modal */
.image-editor-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.editor-container {
  background: #1e293b;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
}

.editor-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.editor-header h3 {
  margin: 0;
  color: var(--text-primary, #e2e8f0);
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: rgba(226, 232, 240, 0.6);
  transition: color 0.3s;
}

.close-btn:hover {
  color: #ef4444;
}

.editor-toolbar {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  flex-wrap: wrap;
}

.editor-toolbar label {
  color: rgba(226, 232, 240, 0.7);
}

.tool-btn {
  padding: 8px 15px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.05);
  color: var(--text-primary, #e2e8f0);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  transition: all 0.3s;
}

.tool-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}

.tool-btn.active {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.4), rgba(139, 92, 246, 0.4));
  color: white;
  border-color: rgba(99, 102, 241, 0.4);
}

.tool-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.editor-toolbar input[type="color"] {
  width: 50px;
  height: 35px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 5px;
  cursor: pointer;
  background: transparent;
}

.editor-toolbar input[type="range"] {
  width: 100px;
}

.canvas-container {
  flex: 1 1;
  overflow: auto;
  padding: 20px;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-canvas {
  border: 2px solid rgba(255, 255, 255, 0.1);
  background: white;
  cursor: crosshair;
  max-width: 100%;
  max-height: 100%;
}

.editor-actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  padding: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

/* Form Actions */
.form-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
}

/* Orders Grid */
.orders-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 20px;
  margin-top: 30px;
}

.order-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s;
}

.order-card:hover {
  border-color: rgba(255, 255, 255, 0.15);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.order-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.order-source {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  color: white;
  font-size: 0.75rem;
  font-weight: 600;
  margin-top: 5px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.order-number {
  font-weight: 600;
  color: rgba(226, 232, 240, 0.6);
  font-size: 0.9rem;
}

.order-status {
  padding: 4px 12px;
  border-radius: 20px;
  color: white;
  font-size: 0.85rem;
  font-weight: 500;
}

.order-body {
  padding: 20px;
}

.order-body h3 {
  margin: 0 0 15px 0;
  color: var(--text-primary, #e2e8f0);
}

.order-phone,
.order-delivery {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 8px 0;
  color: rgba(226, 232, 240, 0.6);
  font-size: 0.95rem;
}

.order-description {
  margin: 12px 0;
  color: rgba(226, 232, 240, 0.7);
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.order-image-indicator {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 10px;
  background: rgba(59, 130, 246, 0.15);
  color: #60a5fa;
  border-radius: 5px;
  font-size: 0.9rem;
  margin-top: 10px;
}

/* Thumbnail in order card */
.order-thumbnail {
  position: relative;
  margin-top: 12px;
  border-radius: 10px;
  overflow: hidden;
  cursor: zoom-in;
  border: 1px solid rgba(255, 255, 255, 0.08);
  aspect-ratio: 16 / 10;
  background: rgba(0, 0, 0, 0.3);
  max-height: 220px;
  transition: all 0.2s;
}

.order-thumbnail:hover {
  border-color: rgba(99, 102, 241, 0.5);
  transform: scale(1.01);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);
}

.order-thumbnail img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.order-thumbnail-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 6px 10px;
  background: linear-gradient(to top, rgba(0,0,0,0.75), transparent);
  color: white;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  gap: 5px;
  opacity: 0;
  transition: opacity 0.2s;
}

.order-thumbnail:hover .order-thumbnail-overlay {
  opacity: 1;
}

.order-thumbnail-loading {
  margin-top: 12px;
  padding: 30px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px dashed rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: rgba(226, 232, 240, 0.5);
  font-size: 0.85rem;
  text-align: center;
}

/* Lightbox */
.image-lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.92);
  backdrop-filter: blur(10px);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  cursor: zoom-out;
}

.image-lightbox img {
  max-width: 95vw;
  max-height: 92vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
  cursor: default;
}

.lightbox-close {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: white;
  font-size: 1.1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.lightbox-close:hover {
  background: rgba(239, 68, 68, 0.7);
  transform: scale(1.08);
}

.order-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: rgba(255, 255, 255, 0.03);
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.order-date {
  color: rgba(226, 232, 240, 0.4);
  font-size: 0.85rem;
}

.order-actions {
  display: flex;
  gap: 8px;
}

/* Buttons */
.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
}

.btn-primary {
  background: linear-gradient(135deg, rgba(99, 102, 241, 0.5), rgba(139, 92, 246, 0.5));
  border: 1px solid rgba(99, 102, 241, 0.3);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);
}

.btn-secondary {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: var(--text-primary, #e2e8f0);
}

.btn-secondary:hover {
  background: rgba(255, 255, 255, 0.12);
}

.btn-success {
  background: rgba(16, 185, 129, 0.3);
  border: 1px solid rgba(16, 185, 129, 0.3);
  color: #6ee7b7;
}

.btn-success:hover {
  background: rgba(16, 185, 129, 0.4);
}

.btn-info {
  background: rgba(59, 130, 246, 0.3);
  border: 1px solid rgba(59, 130, 246, 0.3);
  color: #93c5fd;
}

.btn-info:hover {
  background: rgba(59, 130, 246, 0.4);
}

.btn-danger {
  background: rgba(239, 68, 68, 0.3);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #fca5a5;
}

.btn-danger:hover {
  background: rgba(239, 68, 68, 0.4);
}

.btn-icon {
  padding: 8px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background: transparent;
  transition: all 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
}

.btn-icon.view {
  color: #60a5fa;
}

.btn-icon.view:hover {
  background: rgba(59, 130, 246, 0.15);
  transform: scale(1.1);
}

.btn-icon.edit {
  color: #fbbf24;
}

.btn-icon.edit:hover {
  background: rgba(251, 191, 36, 0.15);
  transform: scale(1.1);
}

.btn-icon.delete {
  color: #f87171;
}

.btn-icon.delete:hover {
  background: rgba(239, 68, 68, 0.15);
  transform: scale(1.1);
}

/* Order Modal */
.order-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
}

.order-modal .modal-content {
  background: #1e293b !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 14px !important;
  width: 96% !important;
  max-width: 1200px !important;
  max-height: 92vh !important;
  overflow: auto !important;
  box-sizing: border-box;
}

.order-modal .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.order-modal .modal-header h2 {
  margin: 0;
  color: var(--text-primary, #e2e8f0);
  font-size: 1.4rem;
}

.order-modal .modal-header button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: rgba(226, 232, 240, 0.6);
}

.order-modal .modal-header button:hover {
  color: #ef4444;
}

.order-modal .modal-body {
  padding: 30px 36px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 32px;
}

.order-modal .detail-row {
  margin-bottom: 0;
  color: var(--text-primary, #e2e8f0);
  font-size: 1rem;
  line-height: 1.6;
  min-width: 0;
}

/* Popis a Obrázok span full width */
.order-modal .detail-row.full-width,
.order-modal .detail-row:has(> .order-description-formatted),
.order-modal .detail-row:has(> .order-detail-image) {
  grid-column: 1 / -1;
}

.order-modal .detail-row strong {
  display: block;
  margin-right: 0;
  margin-bottom: 6px;
  color: rgba(226, 232, 240, 0.5);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  font-weight: 600;
}

.order-modal .detail-row p {
  margin: 0;
  color: rgba(226, 232, 240, 0.9);
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-word;
}

@media (max-width: 768px) {
  .order-modal .modal-body {
    grid-template-columns: 1fr;
    padding: 20px;
  }
}

/* Description Editor with toolbar */
.description-editor {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.3s;
}

.description-editor:focus-within {
  border-color: rgba(99, 102, 241, 0.5);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.description-toolbar {
  display: flex;
  gap: 2px;
  padding: 6px 8px;
  background: rgba(255, 255, 255, 0.05);
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.fmt-btn {
  background: transparent;
  border: none;
  color: rgba(226, 232, 240, 0.6);
  padding: 6px 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.15s;
  display: flex;
  align-items: center;
}

.fmt-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #e2e8f0;
}

.description-editable {
  width: 100%;
  min-height: 140px;
  max-height: 400px;
  overflow-y: auto;
  padding: 12px 15px;
  background: rgba(255, 255, 255, 0.03);
  color: var(--text-primary, #e2e8f0);
  font-size: 1rem;
  line-height: 1.7;
  outline: none;
  box-sizing: border-box;
}

.description-editable:empty::before {
  content: attr(data-placeholder);
  color: rgba(226, 232, 240, 0.3);
  pointer-events: none;
}

.description-editable b,
.description-editable strong {
  font-weight: 700;
  color: #f1f5f9;
}

.description-editable i,
.description-editable em {
  font-style: italic;
}

.description-editable ul {
  margin: 8px 0;
  padding-left: 20px;
}

.description-editable li {
  margin-bottom: 4px;
}

.description-editable hr {
  border: none;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin: 12px 0;
}

.order-description-formatted {
  margin-top: 10px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  color: rgba(226, 232, 240, 0.9);
  font-size: 1rem;
  line-height: 1.8;
}

.order-description-formatted strong {
  display: inline;
  font-size: inherit;
  text-transform: none;
  letter-spacing: normal;
}

.order-description-formatted em {
  font-style: italic;
  color: rgba(226, 232, 240, 0.7);
}

.status-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  color: white;
  font-size: 0.9rem;
  margin-left: 10px;
}

.order-detail-image {
  width: 100%;
  max-width: 100%;
  margin: 15px 0;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Small clickable thumbnail inside the detail modal */
.order-detail-thumb {
  position: relative;
  display: inline-block;
  margin-top: 10px;
  width: 200px;
  max-width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: zoom-in;
  background: rgba(0, 0, 0, 0.25);
  transition: all 0.2s;
}

.order-detail-thumb:hover {
  border-color: rgba(99, 102, 241, 0.5);
  transform: scale(1.02);
}

.order-detail-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Lightbox loading indicator */
.lightbox-loading {
  display: flex;
  align-items: center;
  gap: 10px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 1.1rem;
}

.image-description {
  margin-top: 10px;
  padding: 10px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 5px;
  color: rgba(226, 232, 240, 0.6);
  font-style: italic;
}

/* No Orders */
.no-orders {
  text-align: center;
  padding: 60px 20px;
  color: rgba(226, 232, 240, 0.4);
  font-size: 1.2rem;
}

.no-orders svg {
  font-size: 3rem;
  margin-bottom: 1rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

/* Loading */
.loading {
  text-align: center;
  padding: 60px;
  font-size: 1.2rem;
  color: rgba(226, 232, 240, 0.5);
}

/* Quick Status Buttons */
.quick-status-buttons {
  display: flex;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.quick-status-btn {
  flex: 1 1;
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  transition: all 0.2s;
  font-weight: 500;
}

.quick-status-btn.complete {
  background: rgba(16, 185, 129, 0.25);
  color: #6ee7b7;
  border: 1px solid rgba(16, 185, 129, 0.2);
}

.quick-status-btn.complete:hover {
  background: rgba(16, 185, 129, 0.35);
  transform: translateY(-1px);
}

.quick-status-btn.progress {
  background: rgba(245, 158, 11, 0.25);
  color: #fcd34d;
  border: 1px solid rgba(245, 158, 11, 0.2);
}

.quick-status-btn.progress:hover {
  background: rgba(245, 158, 11, 0.35);
  transform: translateY(-1px);
}

/* Responsive */
@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }

  .search-filter-bar {
    flex-direction: column;
  }

  .search-box {
    min-width: 100%;
  }

  .orders-grid {
    grid-template-columns: 1fr;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .editor-container {
    width: 100%;
    height: 100vh;
    border-radius: 0;
  }
}

/* ============ LIGHT THEME OVERRIDES ============ */
[data-theme="light"] .orders-page,
[data-theme="light"] .order-card,
[data-theme="light"] .order-form,
[data-theme="light"] .order-modal .modal-content {
  color: #1e293b;
}

[data-theme="light"] .order-card {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(0, 0, 0, 0.1);
}

[data-theme="light"] .order-card h3,
[data-theme="light"] .order-form h2,
[data-theme="light"] .form-group label {
  color: #1e293b;
}

[data-theme="light"] .order-phone,
[data-theme="light"] .order-delivery,
[data-theme="light"] .order-description,
[data-theme="light"] .order-date {
  color: #475569;
}

[data-theme="light"] .form-group input,
[data-theme="light"] .form-group textarea,
[data-theme="light"] .form-group select {
  background: rgba(255, 255, 255, 0.9);
  color: #1e293b;
  border: 1px solid rgba(15, 23, 42, 0.15);
}

[data-theme="light"] .form-group input:focus,
[data-theme="light"] .form-group textarea:focus,
[data-theme="light"] .form-group select:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);
}

[data-theme="light"] .search-box {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(0, 0, 0, 0.1);
}

[data-theme="light"] .search-box input {
  color: #1e293b;
}

[data-theme="light"] .modal-content {
  background: white;
}

[data-theme="light"] .no-orders p {
  color: #64748b;
}

/* Submit spinner */
.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

/* ============ Multi-image gallery ============ */
.order-gallery {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 12px;
}

.order-gallery .order-thumbnail {
  margin-top: 0;
  width: 140px;
  aspect-ratio: 4 / 3;
  flex: 0 0 auto;
}

/* In detail modal, allow bigger gallery thumbs */
.order-modal .order-gallery .order-thumbnail {
  width: 180px;
}

/* Existing images block in edit form */
.existing-images-block {
  margin-bottom: 15px;
}

.existing-images-label {
  font-size: 0.8rem;
  color: rgba(226, 232, 240, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
  margin-bottom: 8px;
}

.existing-thumb {
  border-radius: 8px;
  overflow: hidden;
}

.existing-thumb .order-thumbnail {
  margin-top: 0;
  width: 100%;
  aspect-ratio: 4 / 3;
}

.thumb-delete-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: rgba(239, 68, 68, 0.92);
  color: white;
  border: none;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 1;
  z-index: 2;
  transition: transform 0.15s;
}

.thumb-delete-btn:hover {
  transform: scale(1.15);
  background: #ef4444;
}

/* Lightbox navigation arrows */
.lightbox-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: white;
  font-size: 1.3rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  z-index: 5;
}

.lightbox-nav:hover {
  background: rgba(99, 102, 241, 0.6);
  transform: translateY(-50%) scale(1.08);
}

.lightbox-nav.prev { left: 1.5rem; }
.lightbox-nav.next { right: 1.5rem; }

.lightbox-counter {
  position: absolute;
  bottom: 1.5rem;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 0.9rem;
  z-index: 5;
}

@media (max-width: 600px) {
  .lightbox-nav { width: 42px; height: 42px; }
  .lightbox-nav.prev { left: 0.5rem; }
  .lightbox-nav.next { right: 0.5rem; }
}

/* Completed orders collapsible toggle */
.completed-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin: 35px 0 20px;
  padding: 14px 20px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  color: rgba(226, 232, 240, 0.85);
  font-size: 1.05rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.completed-toggle:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.15);
}

.completed-toggle > svg {
  color: rgba(226, 232, 240, 0.6);
  font-size: 0.95rem;
}

.completed-toggle-hint {
  margin-left: auto;
  font-size: 0.8rem;
  font-weight: 500;
  color: rgba(226, 232, 240, 0.45);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
`, "",{"version":3,"sources":["webpack://./src/features/orders/Orders.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,qFAAqF;EACrF,2CAA2C;EAC3C,2BAA2B;EAC3B,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mCAAmC;AACrC;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,2CAA2C;EAC3C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,qFAAqF;EACrF,YAAY;EACZ,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,qCAAqC;EACrC,mCAAmC;EACnC,eAAe;EACf,eAAe;EACf,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,eAAe;AACf;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;EAGE,aAAa;EACb,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,cAAc;EACd,aAAa;EACb,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,kDAAkD;EAClD,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,qFAAqF;EACrF,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,aAAa;EACb,+CAA+C;AACjD;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,qBAAqB;EACrB,8BAA8B;EAC9B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,kEAAkE;EAClE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,qFAAqF;EACrF,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,8BAA8B;EAC9B,qDAAqD;EACrD,8BAA8B;EAC9B,qBAAqB;EACrB,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA,oCAAoC;AACpC;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;IAC1B,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;EACrC,kDAAkD;AACpD;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA,oDAAoD;AACpD;;;;EAIE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;EAGE,oCAAoC;EACpC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;;EAGE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,OAAO,uBAAuB,EAAE;EAChC,OAAO,yBAAyB,EAAE;AACpC;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mCAAmC;EACnC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA,qBAAqB,YAAY,EAAE;AACnC,qBAAqB,aAAa,EAAE;;AAEpC;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,2CAA2C;EAC3C,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,gBAAgB,WAAW,EAAE,YAAY,EAAE;EAC3C,qBAAqB,YAAY,EAAE;EACnC,qBAAqB,aAAa,EAAE;AACtC;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,yBAAyB;EACzB,qBAAqB;AACvB","sourcesContent":[".orders-page {\n  padding: 20px;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n  padding: 20px;\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.3), rgba(139, 92, 246, 0.3));\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(12px);\n  border-radius: 10px;\n  color: var(--text-primary, #e2e8f0);\n}\n\n.page-header h1 {\n  margin: 0;\n  font-size: 2rem;\n  color: var(--text-primary, #e2e8f0);\n}\n\n/* Source Filter Tabs */\n.source-filter-tabs {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  padding: 15px;\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  flex-wrap: wrap;\n}\n\n.source-tab {\n  padding: 10px 20px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 500;\n  color: rgba(226, 232, 240, 0.7);\n  transition: all 0.3s;\n  position: relative;\n}\n\n.source-tab:hover {\n  border-color: rgba(99, 102, 241, 0.4);\n  color: #e2e8f0;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(99, 102, 241, 0.2);\n}\n\n.source-tab.active {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.3), rgba(139, 92, 246, 0.3));\n  color: white;\n  border-color: rgba(99, 102, 241, 0.4);\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);\n}\n\n.source-tab.active::after {\n  content: '';\n  position: absolute;\n  bottom: -10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 30px;\n  height: 3px;\n  background: #6366f1;\n  border-radius: 2px;\n}\n\n/* Search and Filter */\n.search-filter-bar {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n/* Status Filter Section */\n.status-filter-section {\n  background: rgba(255, 255, 255, 0.03);\n  border-radius: 10px;\n  padding: 20px;\n  margin-bottom: 30px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.status-filter-section h3 {\n  margin: 0 0 15px 0;\n  color: var(--text-primary, #e2e8f0);\n  font-size: 1.1rem;\n}\n\n.status-checkboxes {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  margin-bottom: 20px;\n}\n\n.status-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 8px 12px;\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.05);\n  transition: all 0.3s;\n}\n\n.status-checkbox:hover {\n  background: rgba(255, 255, 255, 0.08);\n  transform: translateY(-1px);\n}\n\n.status-checkbox input[type=\"checkbox\"] {\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.status-checkbox span {\n  font-weight: 500;\n  font-size: 0.95rem;\n  color: var(--text-primary, #e2e8f0);\n}\n\n.status-actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.status-actions button {\n  padding: 8px 16px;\n  font-size: 0.9rem;\n}\n\n.search-box {\n  flex: 1;\n  min-width: 300px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 8px;\n  padding: 0 15px;\n}\n\n.search-box svg {\n  color: rgba(226, 232, 240, 0.5);\n  margin-right: 10px;\n}\n\n.search-box input {\n  flex: 1;\n  border: none;\n  outline: none;\n  padding: 12px 0;\n  font-size: 1rem;\n  background: transparent;\n  color: var(--text-primary, #e2e8f0);\n}\n\n.search-box input::placeholder {\n  color: rgba(226, 232, 240, 0.4);\n}\n\n.status-filter {\n  padding: 12px 20px;\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--text-primary, #e2e8f0);\n  font-size: 1rem;\n  cursor: pointer;\n  outline: none;\n  transition: border-color 0.3s;\n}\n\n.status-filter:focus {\n  border-color: rgba(99, 102, 241, 0.5);\n}\n\n/* Order Form */\n.order-form {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(12px);\n  border-radius: 10px;\n  padding: 25px;\n  margin-bottom: 30px;\n}\n\n.order-form h2 {\n  margin-top: 0;\n  color: var(--text-primary, #e2e8f0);\n  margin-bottom: 20px;\n}\n\n.form-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-group label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  color: rgba(226, 232, 240, 0.8);\n  font-weight: 500;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 10px 15px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 5px;\n  font-size: 1rem;\n  transition: border-color 0.3s;\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--text-primary, #e2e8f0);\n}\n\n.form-group input::placeholder,\n.form-group textarea::placeholder {\n  color: rgba(226, 232, 240, 0.35);\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: rgba(99, 102, 241, 0.5);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.form-group select option {\n  background: #1e293b;\n  color: #e2e8f0;\n}\n\n.form-group textarea {\n  resize: vertical;\n  font-family: inherit;\n}\n\n/* Image Section */\n.image-section {\n  margin: 20px 0;\n  padding: 20px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 8px;\n}\n\n.image-section label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 15px;\n  color: rgba(226, 232, 240, 0.8);\n  font-weight: 500;\n}\n\n.image-controls {\n  display: flex;\n  gap: 10px;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n}\n\n.image-preview {\n  max-width: 500px;\n  margin: 15px 0;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.image-preview img {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n/* Image Editor Modal */\n.image-editor-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.editor-container {\n  background: #1e293b;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  width: 90%;\n  max-width: 1200px;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.editor-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.editor-header h3 {\n  margin: 0;\n  color: var(--text-primary, #e2e8f0);\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: rgba(226, 232, 240, 0.6);\n  transition: color 0.3s;\n}\n\n.close-btn:hover {\n  color: #ef4444;\n}\n\n.editor-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 15px 20px;\n  background: rgba(255, 255, 255, 0.03);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  flex-wrap: wrap;\n}\n\n.editor-toolbar label {\n  color: rgba(226, 232, 240, 0.7);\n}\n\n.tool-btn {\n  padding: 8px 15px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 5px;\n  background: rgba(255, 255, 255, 0.05);\n  color: var(--text-primary, #e2e8f0);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  transition: all 0.3s;\n}\n\n.tool-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-1px);\n}\n\n.tool-btn.active {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.4), rgba(139, 92, 246, 0.4));\n  color: white;\n  border-color: rgba(99, 102, 241, 0.4);\n}\n\n.tool-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.editor-toolbar input[type=\"color\"] {\n  width: 50px;\n  height: 35px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 5px;\n  cursor: pointer;\n  background: transparent;\n}\n\n.editor-toolbar input[type=\"range\"] {\n  width: 100px;\n}\n\n.canvas-container {\n  flex: 1;\n  overflow: auto;\n  padding: 20px;\n  background: rgba(0, 0, 0, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.edit-canvas {\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  background: white;\n  cursor: crosshair;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.editor-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: center;\n  padding: 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n/* Form Actions */\n.form-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n/* Orders Grid */\n.orders-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 20px;\n  margin-top: 30px;\n}\n\n.order-card {\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(12px);\n  border-radius: 10px;\n  overflow: hidden;\n  transition: all 0.3s;\n}\n\n.order-card:hover {\n  border-color: rgba(255, 255, 255, 0.15);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n}\n\n.order-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  background: rgba(255, 255, 255, 0.03);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.order-source {\n  display: inline-block;\n  padding: 3px 10px;\n  border-radius: 12px;\n  color: white;\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-top: 5px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.order-number {\n  font-weight: 600;\n  color: rgba(226, 232, 240, 0.6);\n  font-size: 0.9rem;\n}\n\n.order-status {\n  padding: 4px 12px;\n  border-radius: 20px;\n  color: white;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.order-body {\n  padding: 20px;\n}\n\n.order-body h3 {\n  margin: 0 0 15px 0;\n  color: var(--text-primary, #e2e8f0);\n}\n\n.order-phone,\n.order-delivery {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 8px 0;\n  color: rgba(226, 232, 240, 0.6);\n  font-size: 0.95rem;\n}\n\n.order-description {\n  margin: 12px 0;\n  color: rgba(226, 232, 240, 0.7);\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.order-image-indicator {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 10px;\n  background: rgba(59, 130, 246, 0.15);\n  color: #60a5fa;\n  border-radius: 5px;\n  font-size: 0.9rem;\n  margin-top: 10px;\n}\n\n/* Thumbnail in order card */\n.order-thumbnail {\n  position: relative;\n  margin-top: 12px;\n  border-radius: 10px;\n  overflow: hidden;\n  cursor: zoom-in;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  aspect-ratio: 16 / 10;\n  background: rgba(0, 0, 0, 0.3);\n  max-height: 220px;\n  transition: all 0.2s;\n}\n\n.order-thumbnail:hover {\n  border-color: rgba(99, 102, 241, 0.5);\n  transform: scale(1.01);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.35);\n}\n\n.order-thumbnail img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.order-thumbnail-overlay {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  padding: 6px 10px;\n  background: linear-gradient(to top, rgba(0,0,0,0.75), transparent);\n  color: white;\n  font-size: 0.75rem;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  opacity: 0;\n  transition: opacity 0.2s;\n}\n\n.order-thumbnail:hover .order-thumbnail-overlay {\n  opacity: 1;\n}\n\n.order-thumbnail-loading {\n  margin-top: 12px;\n  padding: 30px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px dashed rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  color: rgba(226, 232, 240, 0.5);\n  font-size: 0.85rem;\n  text-align: center;\n}\n\n/* Lightbox */\n.image-lightbox {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.92);\n  backdrop-filter: blur(10px);\n  z-index: 2000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  cursor: zoom-out;\n}\n\n.image-lightbox img {\n  max-width: 95vw;\n  max-height: 92vh;\n  object-fit: contain;\n  border-radius: 8px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);\n  cursor: default;\n}\n\n.lightbox-close {\n  position: absolute;\n  top: 1.5rem;\n  right: 1.5rem;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: white;\n  font-size: 1.1rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.lightbox-close:hover {\n  background: rgba(239, 68, 68, 0.7);\n  transform: scale(1.08);\n}\n\n.order-footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 20px;\n  background: rgba(255, 255, 255, 0.03);\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.order-date {\n  color: rgba(226, 232, 240, 0.4);\n  font-size: 0.85rem;\n}\n\n.order-actions {\n  display: flex;\n  gap: 8px;\n}\n\n/* Buttons */\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, rgba(99, 102, 241, 0.5), rgba(139, 92, 246, 0.5));\n  border: 1px solid rgba(99, 102, 241, 0.3);\n  color: white;\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);\n}\n\n.btn-secondary {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: var(--text-primary, #e2e8f0);\n}\n\n.btn-secondary:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.btn-success {\n  background: rgba(16, 185, 129, 0.3);\n  border: 1px solid rgba(16, 185, 129, 0.3);\n  color: #6ee7b7;\n}\n\n.btn-success:hover {\n  background: rgba(16, 185, 129, 0.4);\n}\n\n.btn-info {\n  background: rgba(59, 130, 246, 0.3);\n  border: 1px solid rgba(59, 130, 246, 0.3);\n  color: #93c5fd;\n}\n\n.btn-info:hover {\n  background: rgba(59, 130, 246, 0.4);\n}\n\n.btn-danger {\n  background: rgba(239, 68, 68, 0.3);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #fca5a5;\n}\n\n.btn-danger:hover {\n  background: rgba(239, 68, 68, 0.4);\n}\n\n.btn-icon {\n  padding: 8px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  background: transparent;\n  transition: all 0.3s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.1rem;\n}\n\n.btn-icon.view {\n  color: #60a5fa;\n}\n\n.btn-icon.view:hover {\n  background: rgba(59, 130, 246, 0.15);\n  transform: scale(1.1);\n}\n\n.btn-icon.edit {\n  color: #fbbf24;\n}\n\n.btn-icon.edit:hover {\n  background: rgba(251, 191, 36, 0.15);\n  transform: scale(1.1);\n}\n\n.btn-icon.delete {\n  color: #f87171;\n}\n\n.btn-icon.delete:hover {\n  background: rgba(239, 68, 68, 0.15);\n  transform: scale(1.1);\n}\n\n/* Order Modal */\n.order-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999;\n}\n\n.order-modal .modal-content {\n  background: #1e293b !important;\n  border: 1px solid rgba(255, 255, 255, 0.1) !important;\n  border-radius: 14px !important;\n  width: 96% !important;\n  max-width: 1200px !important;\n  max-height: 92vh !important;\n  overflow: auto !important;\n  box-sizing: border-box;\n}\n\n.order-modal .modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 32px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.order-modal .modal-header h2 {\n  margin: 0;\n  color: var(--text-primary, #e2e8f0);\n  font-size: 1.4rem;\n}\n\n.order-modal .modal-header button {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: rgba(226, 232, 240, 0.6);\n}\n\n.order-modal .modal-header button:hover {\n  color: #ef4444;\n}\n\n.order-modal .modal-body {\n  padding: 30px 36px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px 32px;\n}\n\n.order-modal .detail-row {\n  margin-bottom: 0;\n  color: var(--text-primary, #e2e8f0);\n  font-size: 1rem;\n  line-height: 1.6;\n  min-width: 0;\n}\n\n/* Popis a Obrázok span full width */\n.order-modal .detail-row.full-width,\n.order-modal .detail-row:has(> .order-description-formatted),\n.order-modal .detail-row:has(> .order-detail-image) {\n  grid-column: 1 / -1;\n}\n\n.order-modal .detail-row strong {\n  display: block;\n  margin-right: 0;\n  margin-bottom: 6px;\n  color: rgba(226, 232, 240, 0.5);\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  font-weight: 600;\n}\n\n.order-modal .detail-row p {\n  margin: 0;\n  color: rgba(226, 232, 240, 0.9);\n  line-height: 1.6;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n@media (max-width: 768px) {\n  .order-modal .modal-body {\n    grid-template-columns: 1fr;\n    padding: 20px;\n  }\n}\n\n/* Description Editor with toolbar */\n.description-editor {\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  overflow: hidden;\n  transition: border-color 0.3s;\n}\n\n.description-editor:focus-within {\n  border-color: rgba(99, 102, 241, 0.5);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.description-toolbar {\n  display: flex;\n  gap: 2px;\n  padding: 6px 8px;\n  background: rgba(255, 255, 255, 0.05);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.fmt-btn {\n  background: transparent;\n  border: none;\n  color: rgba(226, 232, 240, 0.6);\n  padding: 6px 10px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.15s;\n  display: flex;\n  align-items: center;\n}\n\n.fmt-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #e2e8f0;\n}\n\n.description-editable {\n  width: 100%;\n  min-height: 140px;\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 12px 15px;\n  background: rgba(255, 255, 255, 0.03);\n  color: var(--text-primary, #e2e8f0);\n  font-size: 1rem;\n  line-height: 1.7;\n  outline: none;\n  box-sizing: border-box;\n}\n\n.description-editable:empty::before {\n  content: attr(data-placeholder);\n  color: rgba(226, 232, 240, 0.3);\n  pointer-events: none;\n}\n\n.description-editable b,\n.description-editable strong {\n  font-weight: 700;\n  color: #f1f5f9;\n}\n\n.description-editable i,\n.description-editable em {\n  font-style: italic;\n}\n\n.description-editable ul {\n  margin: 8px 0;\n  padding-left: 20px;\n}\n\n.description-editable li {\n  margin-bottom: 4px;\n}\n\n.description-editable hr {\n  border: none;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  margin: 12px 0;\n}\n\n.order-description-formatted {\n  margin-top: 10px;\n  padding: 20px 24px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 10px;\n  color: rgba(226, 232, 240, 0.9);\n  font-size: 1rem;\n  line-height: 1.8;\n}\n\n.order-description-formatted strong {\n  display: inline;\n  font-size: inherit;\n  text-transform: none;\n  letter-spacing: normal;\n}\n\n.order-description-formatted em {\n  font-style: italic;\n  color: rgba(226, 232, 240, 0.7);\n}\n\n.status-badge {\n  display: inline-block;\n  padding: 4px 12px;\n  border-radius: 20px;\n  color: white;\n  font-size: 0.9rem;\n  margin-left: 10px;\n}\n\n.order-detail-image {\n  width: 100%;\n  max-width: 100%;\n  margin: 15px 0;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Small clickable thumbnail inside the detail modal */\n.order-detail-thumb {\n  position: relative;\n  display: inline-block;\n  margin-top: 10px;\n  width: 200px;\n  max-width: 100%;\n  aspect-ratio: 4 / 3;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  cursor: zoom-in;\n  background: rgba(0, 0, 0, 0.25);\n  transition: all 0.2s;\n}\n\n.order-detail-thumb:hover {\n  border-color: rgba(99, 102, 241, 0.5);\n  transform: scale(1.02);\n}\n\n.order-detail-thumb img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Lightbox loading indicator */\n.lightbox-loading {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 1.1rem;\n}\n\n.image-description {\n  margin-top: 10px;\n  padding: 10px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 5px;\n  color: rgba(226, 232, 240, 0.6);\n  font-style: italic;\n}\n\n/* No Orders */\n.no-orders {\n  text-align: center;\n  padding: 60px 20px;\n  color: rgba(226, 232, 240, 0.4);\n  font-size: 1.2rem;\n}\n\n.no-orders svg {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/* Loading */\n.loading {\n  text-align: center;\n  padding: 60px;\n  font-size: 1.2rem;\n  color: rgba(226, 232, 240, 0.5);\n}\n\n/* Quick Status Buttons */\n.quick-status-buttons {\n  display: flex;\n  gap: 8px;\n  padding: 12px 20px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.quick-status-btn {\n  flex: 1;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  transition: all 0.2s;\n  font-weight: 500;\n}\n\n.quick-status-btn.complete {\n  background: rgba(16, 185, 129, 0.25);\n  color: #6ee7b7;\n  border: 1px solid rgba(16, 185, 129, 0.2);\n}\n\n.quick-status-btn.complete:hover {\n  background: rgba(16, 185, 129, 0.35);\n  transform: translateY(-1px);\n}\n\n.quick-status-btn.progress {\n  background: rgba(245, 158, 11, 0.25);\n  color: #fcd34d;\n  border: 1px solid rgba(245, 158, 11, 0.2);\n}\n\n.quick-status-btn.progress:hover {\n  background: rgba(245, 158, 11, 0.35);\n  transform: translateY(-1px);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .page-header {\n    flex-direction: column;\n    gap: 15px;\n    text-align: center;\n  }\n\n  .search-filter-bar {\n    flex-direction: column;\n  }\n\n  .search-box {\n    min-width: 100%;\n  }\n\n  .orders-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .editor-container {\n    width: 100%;\n    height: 100vh;\n    border-radius: 0;\n  }\n}\n\n/* ============ LIGHT THEME OVERRIDES ============ */\n[data-theme=\"light\"] .orders-page,\n[data-theme=\"light\"] .order-card,\n[data-theme=\"light\"] .order-form,\n[data-theme=\"light\"] .order-modal .modal-content {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .order-card {\n  background: rgba(255, 255, 255, 0.9);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n[data-theme=\"light\"] .order-card h3,\n[data-theme=\"light\"] .order-form h2,\n[data-theme=\"light\"] .form-group label {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .order-phone,\n[data-theme=\"light\"] .order-delivery,\n[data-theme=\"light\"] .order-description,\n[data-theme=\"light\"] .order-date {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .form-group input,\n[data-theme=\"light\"] .form-group textarea,\n[data-theme=\"light\"] .form-group select {\n  background: rgba(255, 255, 255, 0.9);\n  color: #1e293b;\n  border: 1px solid rgba(15, 23, 42, 0.15);\n}\n\n[data-theme=\"light\"] .form-group input:focus,\n[data-theme=\"light\"] .form-group textarea:focus,\n[data-theme=\"light\"] .form-group select:focus {\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);\n}\n\n[data-theme=\"light\"] .search-box {\n  background: rgba(255, 255, 255, 0.9);\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n[data-theme=\"light\"] .search-box input {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .modal-content {\n  background: white;\n}\n\n[data-theme=\"light\"] .no-orders p {\n  color: #64748b;\n}\n\n/* Submit spinner */\n.btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to   { transform: rotate(360deg); }\n}\n\n/* ============ Multi-image gallery ============ */\n.order-gallery {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 12px;\n}\n\n.order-gallery .order-thumbnail {\n  margin-top: 0;\n  width: 140px;\n  aspect-ratio: 4 / 3;\n  flex: 0 0 auto;\n}\n\n/* In detail modal, allow bigger gallery thumbs */\n.order-modal .order-gallery .order-thumbnail {\n  width: 180px;\n}\n\n/* Existing images block in edit form */\n.existing-images-block {\n  margin-bottom: 15px;\n}\n\n.existing-images-label {\n  font-size: 0.8rem;\n  color: rgba(226, 232, 240, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  font-weight: 600;\n  margin-bottom: 8px;\n}\n\n.existing-thumb {\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.existing-thumb .order-thumbnail {\n  margin-top: 0;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n}\n\n.thumb-delete-btn {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  background: rgba(239, 68, 68, 0.92);\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 26px;\n  height: 26px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  line-height: 1;\n  z-index: 2;\n  transition: transform 0.15s;\n}\n\n.thumb-delete-btn:hover {\n  transform: scale(1.15);\n  background: #ef4444;\n}\n\n/* Lightbox navigation arrows */\n.lightbox-nav {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.12);\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  color: white;\n  font-size: 1.3rem;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n  z-index: 5;\n}\n\n.lightbox-nav:hover {\n  background: rgba(99, 102, 241, 0.6);\n  transform: translateY(-50%) scale(1.08);\n}\n\n.lightbox-nav.prev { left: 1.5rem; }\n.lightbox-nav.next { right: 1.5rem; }\n\n.lightbox-counter {\n  position: absolute;\n  bottom: 1.5rem;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.6);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  color: white;\n  padding: 6px 16px;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  z-index: 5;\n}\n\n@media (max-width: 600px) {\n  .lightbox-nav { width: 42px; height: 42px; }\n  .lightbox-nav.prev { left: 0.5rem; }\n  .lightbox-nav.next { right: 0.5rem; }\n}\n\n/* Completed orders collapsible toggle */\n.completed-toggle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  margin: 35px 0 20px;\n  padding: 14px 20px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 10px;\n  color: rgba(226, 232, 240, 0.85);\n  font-size: 1.05rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.completed-toggle:hover {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n.completed-toggle > svg {\n  color: rgba(226, 232, 240, 0.6);\n  font-size: 0.95rem;\n}\n\n.completed-toggle-hint {\n  margin-left: auto;\n  font-size: 0.8rem;\n  font-weight: 500;\n  color: rgba(226, 232, 240, 0.45);\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
